import c from './index.less';

export const SERVICE_TIP = (
    <>
        <div>全量接入：所有实例流量均已部署，策略完全可用；</div>
        <div>接入中：部分实例部署，策略仅对部分实例生效，请关注；</div>
        <div>未使用：服务发出和接收的流量均不会被代理。</div>
    </>
);
export const NoData = <div className={c['no-data']}>N/A<span className={c['unit']}>个</span></div>;
